import http from "../http";

const AuthAPI = {
  login: async (email, password) => {
    const res = await http.post("/auth/login", { email, password });
    const { token, user } = res.data;
    // Save token for future requests
    localStorage.setItem("token", token);
    return { token, user };
  },

  // Register (admin only)
  register: async (data) => {
    const res = await http.post("/auth/register", data);
    return res.data;
  },

  // Get all users (admin only)
  getUsers: async () => {
    const res = await http.get("/auth/users");
    return res.data;
  },

  // Logout
  logout: () => {
    localStorage.removeItem("token");
  },
};

export default AuthAPI;
